(function () {
  if (window.FilaMembershipSection) {
    window.FilaMembershipSection.initAll(document);
    return;
  }

  var ROOT_SELECTOR = '[data-membership-section]';
  var MOBILE_QUERY = '(max-width: 749px)';

  function getSlider(root) {
    return root && root.querySelector('[data-membership-slider]');
  }

  function getSlides(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-membership-slide]'));
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getAutoplayInterval(root) {
    return parseInt(root.dataset.autoplayInterval, 10) || 5000;
  }

  function getAutoplayResumeDelay(root) {
    return parseInt(root.dataset.autoplayResumeDelay, 10) || getAutoplayInterval(root);
  }

  function isAutoplayEnabled(root) {
    if (!root || prefersReducedMotion() || document.hidden) return false;

    if (window.matchMedia(MOBILE_QUERY).matches) {
      return root.dataset.mobileAutoplay === 'true';
    }

    return root.dataset.desktopAutoplay === 'true';
  }

  function clearAutoplay(root) {
    if (!root || !root._membershipAutoplayTimer) return;

    window.clearTimeout(root._membershipAutoplayTimer);
    delete root._membershipAutoplayTimer;
  }

  function hasAutoplayPauseReason(root) {
    return root._membershipAutoplayPauseReasons && Object.keys(root._membershipAutoplayPauseReasons).length > 0;
  }

  function pauseAutoplay(root, reason) {
    if (!root) return;

    root._membershipAutoplayPauseReasons = root._membershipAutoplayPauseReasons || {};
    root._membershipAutoplayPauseReasons[reason] = true;
    clearAutoplay(root);
  }

  function resumeAutoplay(root, reason) {
    if (!root) return;

    if (root._membershipAutoplayPauseReasons) {
      delete root._membershipAutoplayPauseReasons[reason];
    }

    if (!hasAutoplayPauseReason(root)) {
      scheduleAutoplay(root, getAutoplayResumeDelay(root));
    }
  }

  function setActiveSlide(root, activeSlide) {
    if (!root || !activeSlide) return;

    getSlides(root).forEach(function (slide) {
      var active = slide === activeSlide;
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.setAttribute('aria-current', 'true');
      } else {
        slide.removeAttribute('aria-current');
      }
    });

    root.classList.add('is-interactive');
  }

  function setInitialActiveSlide(root) {
    var slides = getSlides(root);
    if (!slides.length) return;

    var highlighted = root.querySelector('[data-membership-slide].is-highlighted');
    setActiveSlide(root, highlighted || slides[0]);
  }

  function clearInteractionTimer(root) {
    if (!root) return;

    if (root._membershipInteractionTimer) {
      window.clearTimeout(root._membershipInteractionTimer);
      delete root._membershipInteractionTimer;
    }
  }

  function scheduleInteractionEnd(root, delay) {
    if (!root) return;

    clearInteractionTimer(root);

    root._membershipInteractionTimer = window.setTimeout(function () {
      delete root._membershipInteractionTimer;
      root._membershipInteractionMode = 'idle';
    }, typeof delay === 'number' ? delay : 180);
  }

  function beginSwipeInteraction(root) {
    if (!root) return;

    clearInteractionTimer(root);
    if (root._membershipActiveFrame) {
      window.cancelAnimationFrame(root._membershipActiveFrame);
      delete root._membershipActiveFrame;
    }
    root._membershipInteractionMode = 'swipe';
  }

  function activateSlide(root, slide, behavior) {
    if (!root || !slide) return;

    if (!window.matchMedia(MOBILE_QUERY).matches) {
      setActiveSlide(root, slide);
      return;
    }

    clearInteractionTimer(root);
    if (root._membershipActiveFrame) {
      window.cancelAnimationFrame(root._membershipActiveFrame);
      delete root._membershipActiveFrame;
    }
    root._membershipInteractionMode = 'programmatic';
    setActiveSlide(root, slide);
    centerSlide(root, slide, behavior || 'smooth');
    scheduleInteractionEnd(root, 2000);
  }

  function getCarouselMetrics(root) {
    var slider = getSlider(root);
    if (!slider) return null;

    var endPadding = parseInt(slider.dataset.mobileEndPadding, 10) || 0;

    return {
      startSpace: 0,
      endSpace: endPadding
    };
  }

  function scrollSlider(slider, left, behavior) {
    var target = Math.max(0, Math.min(left, slider.scrollWidth - slider.clientWidth));

    if (typeof slider.scrollTo === 'function') {
      slider.scrollTo({
        left: target,
        behavior: prefersReducedMotion() ? 'auto' : behavior
      });
    } else {
      slider.scrollLeft = target;
    }
  }

  function centerSlide(root, slide, behavior) {
    var slider = getSlider(root);
    if (!slider || !slide || !window.matchMedia(MOBILE_QUERY).matches) return;

    var slides = getSlides(root);
    var rootRect = root.getBoundingClientRect();
    var slideRect = slide.getBoundingClientRect();
    var viewportCenter = rootRect.left + rootRect.width / 2;
    var slideCenter = slideRect.left + slideRect.width / 2;
    var target = slider.scrollLeft + slideCenter - viewportCenter;

    // Edge cards align with the section padding; only the inner cards center.
    if (slide === slides[0]) target = 0;
    if (slide === slides[slides.length - 1]) target = slider.scrollWidth - slider.clientWidth;

    scrollSlider(slider, target, behavior || 'smooth');
  }

  function scheduleAutoplay(root, delay) {
    clearAutoplay(root);

    var slides = getSlides(root);
    if (!isAutoplayEnabled(root) || hasAutoplayPauseReason(root) || slides.length < 2) return;

    root._membershipAutoplayTimer = window.setTimeout(function () {
      delete root._membershipAutoplayTimer;
      if (!root.isConnected || !isAutoplayEnabled(root) || hasAutoplayPauseReason(root)) return;

      var activeSlide = root.querySelector('[data-membership-slide].is-active');
      var currentIndex = slides.indexOf(activeSlide);
      var nextSlide = slides[(currentIndex + 1 + slides.length) % slides.length];

      root._membershipHasInteracted = true;

      if (window.matchMedia(MOBILE_QUERY).matches) {
        activateSlide(root, nextSlide, 'smooth');
      } else {
        setActiveSlide(root, nextSlide);
      }

      scheduleAutoplay(root, getAutoplayInterval(root));
    }, typeof delay === 'number' ? delay : getAutoplayInterval(root));
  }

  function restartAutoplay(root) {
    clearAutoplay(root);
    if (!hasAutoplayPauseReason(root)) {
      scheduleAutoplay(root, getAutoplayResumeDelay(root));
    }
  }

  function alignInitialSlide(root, startSpace) {
    var slider = getSlider(root);
    if (!slider) return;

    var previousBehavior = slider.style.scrollBehavior;
    slider.style.scrollBehavior = 'auto';
    slider.scrollLeft = startSpace;
    slider.style.scrollBehavior = previousBehavior;
  }

  function updateCarouselSpacing(root) {
    var slider = getSlider(root);
    var metrics = getCarouselMetrics(root);
    if (!slider || !metrics) return;

    slider.style.setProperty('--ms-carousel-start-space', metrics.startSpace + 'px');
    slider.style.setProperty('--ms-carousel-end-space', metrics.endSpace + 'px');

    // Force the new track padding to be reflected before setting scrollLeft.
    void slider.offsetWidth;

    var activeSlide = root.querySelector('[data-membership-slide].is-active');
    if (root._membershipHasInteracted && activeSlide) {
      centerSlide(root, activeSlide, 'auto');
    } else {
      // The native scroll boundary keeps the first card flush with the heading.
      alignInitialSlide(root, metrics.startSpace);
    }
  }

  function updateCenteredSlide(root) {
    if (
      !root ||
      root.dataset.mobileCenterActivation !== 'true' ||
      root._membershipInteractionMode !== 'swipe'
    ) return;

    if (root._membershipActiveFrame) {
      window.cancelAnimationFrame(root._membershipActiveFrame);
    }

    root._membershipActiveFrame = window.requestAnimationFrame(function () {
      delete root._membershipActiveFrame;
      if (root._membershipInteractionMode !== 'swipe') return;

      var rootRect = root.getBoundingClientRect();
      var viewportCenter = rootRect.left + rootRect.width / 2;
      var closestSlide = null;
      var closestDistance = Infinity;

      getSlides(root).forEach(function (slide) {
        var rect = slide.getBoundingClientRect();
        var visible = rect.right > rootRect.left && rect.left < rootRect.right;
        if (!visible) return;

        var distance = Math.abs(rect.left + rect.width / 2 - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
        }
      });

      if (closestSlide) setActiveSlide(root, closestSlide);
    });
  }

  function destroyCarousel(root) {
    var slider = getSlider(root);
    if (!slider) return;

    if (root._membershipScrollHandler) {
      slider.removeEventListener('scroll', root._membershipScrollHandler);
      delete root._membershipScrollHandler;
    }

    if (root._membershipTouchHandler) {
      slider.removeEventListener('touchstart', root._membershipTouchHandler);
      delete root._membershipTouchHandler;
    }

    if (root._membershipTouchEndHandler) {
      slider.removeEventListener('touchend', root._membershipTouchEndHandler);
      slider.removeEventListener('touchcancel', root._membershipTouchEndHandler);
      delete root._membershipTouchEndHandler;
    }

    if (root._membershipWheelHandler) {
      slider.removeEventListener('wheel', root._membershipWheelHandler);
      delete root._membershipWheelHandler;
    }

    if (root._membershipResizeHandler) {
      window.removeEventListener('resize', root._membershipResizeHandler);
      delete root._membershipResizeHandler;
    }

    slider.style.removeProperty('--ms-carousel-start-space');
    slider.style.removeProperty('--ms-carousel-end-space');
    slider.removeAttribute('data-membership-carousel-ready');
    slider.scrollLeft = 0;
    clearInteractionTimer(root);
    delete root._membershipInteractionMode;
    delete root._membershipHasInteracted;
  }

  function createCarousel(root) {
    var slider = getSlider(root);
    var slides = getSlides(root);
    if (!slider || slides.length < 2 || slider.hasAttribute('data-membership-carousel-ready')) return;

    root._membershipHasInteracted = false;
    root._membershipInteractionMode = 'idle';
    root._membershipScrollHandler = function () {
      if (root._membershipInteractionMode === 'swipe') {
        updateCenteredSlide(root);
        scheduleInteractionEnd(root);
      } else if (root._membershipInteractionMode === 'programmatic') {
        scheduleInteractionEnd(root);
      }
    };
    root._membershipTouchHandler = function () {
      root._membershipHasInteracted = true;
      beginSwipeInteraction(root);
      pauseAutoplay(root, 'touch');
    };
    root._membershipTouchEndHandler = function () {
      scheduleInteractionEnd(root);
      resumeAutoplay(root, 'touch');
    };
    root._membershipWheelHandler = function (event) {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

      root._membershipHasInteracted = true;
      beginSwipeInteraction(root);
    };
    root._membershipResizeHandler = function () {
      updateCarouselSpacing(root);
    };

    slider.addEventListener('scroll', root._membershipScrollHandler, { passive: true });
    slider.addEventListener('touchstart', root._membershipTouchHandler, { passive: true });
    slider.addEventListener('touchend', root._membershipTouchEndHandler, { passive: true });
    slider.addEventListener('touchcancel', root._membershipTouchEndHandler, { passive: true });
    slider.addEventListener('wheel', root._membershipWheelHandler, { passive: true });
    window.addEventListener('resize', root._membershipResizeHandler);
    slider.setAttribute('data-membership-carousel-ready', 'true');

    updateCarouselSpacing(root);
  }

  function cleanupRoot(root) {
    if (!root) return;

    clearAutoplay(root);
    destroyCarousel(root);

    if (root._membershipActiveFrame) {
      window.cancelAnimationFrame(root._membershipActiveFrame);
      delete root._membershipActiveFrame;
    }

    if (root._membershipClickHandler) {
      root.removeEventListener('click', root._membershipClickHandler);
      delete root._membershipClickHandler;
    }

    if (root._membershipKeyHandler) {
      root.removeEventListener('keydown', root._membershipKeyHandler);
      delete root._membershipKeyHandler;
    }

    if (root._membershipMouseEnterHandler) {
      root.removeEventListener('mouseenter', root._membershipMouseEnterHandler);
      delete root._membershipMouseEnterHandler;
    }

    if (root._membershipMouseLeaveHandler) {
      root.removeEventListener('mouseleave', root._membershipMouseLeaveHandler);
      delete root._membershipMouseLeaveHandler;
    }

    if (root._membershipFocusInHandler) {
      root.removeEventListener('focusin', root._membershipFocusInHandler);
      delete root._membershipFocusInHandler;
    }

    if (root._membershipFocusOutHandler) {
      root.removeEventListener('focusout', root._membershipFocusOutHandler);
      delete root._membershipFocusOutHandler;
    }

    if (root._membershipPointerDownHandler) {
      root.removeEventListener('pointerdown', root._membershipPointerDownHandler);
      delete root._membershipPointerDownHandler;
    }

    if (root._membershipPointerFocusTimer) {
      window.clearTimeout(root._membershipPointerFocusTimer);
      delete root._membershipPointerFocusTimer;
    }

    if (root._membershipVisibilityHandler) {
      document.removeEventListener('visibilitychange', root._membershipVisibilityHandler);
      delete root._membershipVisibilityHandler;
    }

    if (root._membershipMedia && root._membershipSync) {
      if (root._membershipMedia.removeEventListener) {
        root._membershipMedia.removeEventListener('change', root._membershipSync);
      } else if (root._membershipMedia.removeListener) {
        root._membershipMedia.removeListener(root._membershipSync);
      }
    }

    delete root._membershipMedia;
    delete root._membershipSync;
    delete root._membershipAutoplayPauseReasons;
    delete root._membershipPointerFocus;
    delete root.dataset.membershipInitialized;
    root.classList.remove('is-interactive');
    getSlides(root).forEach(function (slide) {
      slide.classList.remove('is-active');
      slide.removeAttribute('aria-current');
    });
  }

  function initRoot(root) {
    if (!root) return;
    cleanupRoot(root);
    setInitialActiveSlide(root);

    if (root.dataset.clickActivation === 'true') {
      root._membershipClickHandler = function (event) {
        var slide = event.target.closest && event.target.closest('[data-membership-slide]');
        if (!slide || !root.contains(slide)) return;

        root._membershipHasInteracted = true;
        activateSlide(root, slide, 'smooth');
        restartAutoplay(root);
      };

      root._membershipKeyHandler = function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        var activator = event.target.closest && event.target.closest('[data-membership-activator]');
        var slide = event.target.closest && event.target.closest('[data-membership-slide]');
        if (!activator || !slide || activator.tagName === 'A') return;

        event.preventDefault();
        root._membershipHasInteracted = true;
        activateSlide(root, slide, 'smooth');
        restartAutoplay(root);
      };

      root.addEventListener('click', root._membershipClickHandler);
      root.addEventListener('keydown', root._membershipKeyHandler);
    }

    var media = window.matchMedia(MOBILE_QUERY);
    var sync = function () {
      if (media.matches) {
        createCarousel(root);
      } else {
        destroyCarousel(root);
      }

      scheduleAutoplay(root, getAutoplayInterval(root));
    };

    root._membershipMouseEnterHandler = function () {
      if (!media.matches) pauseAutoplay(root, 'hover');
    };
    root._membershipMouseLeaveHandler = function () {
      resumeAutoplay(root, 'hover');
    };
    root._membershipPointerDownHandler = function () {
      root._membershipPointerFocus = true;
      if (root._membershipPointerFocusTimer) {
        window.clearTimeout(root._membershipPointerFocusTimer);
      }
      root._membershipPointerFocusTimer = window.setTimeout(function () {
        delete root._membershipPointerFocus;
        delete root._membershipPointerFocusTimer;
      }, 0);
    };
    root._membershipFocusInHandler = function () {
      if (!root._membershipPointerFocus) pauseAutoplay(root, 'focus');
    };
    root._membershipFocusOutHandler = function (event) {
      if (!event.relatedTarget || !root.contains(event.relatedTarget)) {
        resumeAutoplay(root, 'focus');
      }
    };
    root._membershipVisibilityHandler = function () {
      if (document.hidden) {
        clearAutoplay(root);
      } else {
        scheduleAutoplay(root, getAutoplayResumeDelay(root));
      }
    };

    root.addEventListener('mouseenter', root._membershipMouseEnterHandler);
    root.addEventListener('mouseleave', root._membershipMouseLeaveHandler);
    root.addEventListener('pointerdown', root._membershipPointerDownHandler, { passive: true });
    root.addEventListener('focusin', root._membershipFocusInHandler);
    root.addEventListener('focusout', root._membershipFocusOutHandler);
    document.addEventListener('visibilitychange', root._membershipVisibilityHandler);

    root._membershipMedia = media;
    root._membershipSync = sync;
    root.dataset.membershipInitialized = 'true';

    if (media.addEventListener) {
      media.addEventListener('change', sync);
    } else if (media.addListener) {
      media.addListener(sync);
    }

    sync();
  }

  function findRoots(scope) {
    var roots = [];
    var context = scope || document;

    if (context.matches && context.matches(ROOT_SELECTOR)) {
      roots.push(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        roots.push(root);
      });
    }

    return roots;
  }

  function initAll(scope) {
    findRoots(scope).forEach(initRoot);
  }

  window.FilaMembershipSection = {
    initAll: initAll,
    initRoot: initRoot,
    cleanupRoot: cleanupRoot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    findRoots(event.target).forEach(cleanupRoot);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest && event.target.closest(ROOT_SELECTOR);
    if (!root) return;

    var selectedSlide = event.target.closest && event.target.closest('[data-membership-slide]');
    if (!selectedSlide) return;

    root._membershipHasInteracted = true;
    activateSlide(root, selectedSlide, 'auto');
    restartAutoplay(root);
  });
})();
